import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { VipContentComponent } from './vip-content-modal/vip-content-modal.component';
import { VipRestrictedModalComponent } from './vip-restricted-modal/vip-restricted-modal.component';
import './vip.cms-config';
import { VipService } from './vip.service';
@NgModule({
    declarations: [],
    imports: [CommonModule]
})
export class VipModule {
    constructor(vipService: VipService) {
        surviveTreeShaking(VipContentComponent, VipRestrictedModalComponent);
    }
}
